import React, { useState } from "react";

// import JS files

// import Others files
import waitingIcon from "../../../imgs/waiting.svg";

const Waiting = (props) => {
  return (
    <>
      <div className="md:col-span-3 flex flex-col items-center justify-center">
        <img src={waitingIcon} />
        {props.isSoon && (
          <p className="font-bold text-mygray-700 mt-8">به زودی!</p>
        )}
        <p className="text-sm leading-8 text-mygray-500 mt-8 text-center">
          {props.text}
        </p>
      </div>
    </>
  );
};

export default Waiting;
